<template>
  <div>
    <div class="my-6">
      <span>
        If an Instructor who created this course receives royalties for it, add
        the details here:
      </span>
    </div>
    <v-row>
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12" md="5">
            <div class="">
              <span><b> Add Instructor </b> </span>
            </div>
            <div class="mt-3">
              <v-select dense outlined single-line hide-details=" "> </v-select>
            </div>
          </v-col>
          <v-col cols="12" md="5">
            <div class="">
              <span><b> Royalties rate per purchase </b> </span>
            </div>
            <div class="mt-3">
              <v-text-field dense outlined single-line hide-details="">
              </v-text-field>
            </div>
            <div class="d-flex justify-center">
              <div class="mt-5"><span class="pa-3">Flat Rate </span></div>
              <v-switch color="primary" value input-value="true"></v-switch>
              <div class="mt-5"><span class="pa-3">Percentage </span></div>
            </div>
          </v-col>
          <v-col cols="12" md="1">
            <div class="d-flex justify-space-between">
              <v-icon class="mt-11" color="red">mdi-delete </v-icon>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-for="(div, index) in divs" :key="div.id" :div="(div = index)">
      <v-row>
        <v-col cols="12" md="8">
          <v-row>
            <v-col cols="12" md="5">
              <div class="">
                <span><b> Add Instructor </b> </span>
              </div>
              <div class="mt-3">
                <v-select dense outlined single-line hide-details=" ">
                </v-select>
              </div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="">
                <span><b> Royalties rate per purchase </b> </span>
              </div>
              <div class="mt-3">
                <v-text-field dense outlined single-line hide-details="">
                </v-text-field>
              </div>
              <div class="d-flex justify-center">
                <div class="mt-5"><span class="pa-3">Flat Rate </span></div>
                <v-switch color="primary" value input-value="true"></v-switch>
                <div class="mt-5"><span class="pa-3">Percentage </span></div>
              </div>
            </v-col>
            <v-col cols="12" md="1">
              <div class="d-flex justify-space-between">
                <v-icon class="mt-11" color="red" @click="deleteRow(index)"
                  >mdi-delete
                </v-icon>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-btn class="text_trans" text color="primary" @click="addRow">
        + Add another Instructor
      </v-btn>
    </div>
    <div class="">
      <span>Send royalty payment directly to Instructor after purchase? </span>
      <div>
        <v-radio-group v-model="radios" mandatory row>
          <v-radio label="Yes" value="radio-1"></v-radio>
          <v-radio label="No" value="radio-2"></v-radio>
        </v-radio-group>
      </div>
    </div>
    <div class="">
      <span
        >Email the Instructor the student’s first name and email address on
        purchase?
      </span>
      <div>
        <v-radio-group v-model="radios1" mandatory row>
          <v-radio label="Yes" value="radio-1"></v-radio>
          <v-radio label="No" value="radio-2"></v-radio>
        </v-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      radios: "radio-2",
      radios1: "radio-1",
      div: 0,
      divs: [],
    };
  },
  methods: {
    addRow() {
      this.divs.push({
        div: this.div,
      });
    },
    deleteRow(index) {
      this.divs.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.text_trans {
  text-transform: none;
}
</style>
